/**
 * API 根路径：开发默认 /prod-api（走 vue.config.js 代理）；生产构建用 .env.production 的 VUE_APP_API_BASE。
 * 前后端分离示例：VUE_APP_API_BASE=https://api.你的域名/prod-api
 */
function normalizeBase(url) {
  if (!url) return "/prod-api";
  return String(url).replace(/\/+$/, "");
}

export function getApiBase() {
  return normalizeBase(process.env.VUE_APP_API_BASE);
}

/** 统一上传地址（Element Upload 的 action，全部走腾讯云 COS） */
export function getUploadAction(biz) {
  return getApiBase() + "/common/upload?biz=" + encodeURIComponent(biz || "image");
}
